import "./CitizenScience.module.css";
import Header from "@/reusable_sections/Header";
import CitizenScienceHub from "./sections/CitizenScienceHub";
import Telemetryvisualization from "./sections/Telemetryvisualization";
import ContributionsEquipment from "./sections/ContributionsEquipment";
import Footer from "@/reusable_sections/Footer";
export default function CitizenSciencePage() {
  return <div>
      <Header />
      <CitizenScienceHub />
      <Telemetryvisualization />
      <ContributionsEquipment />
      <Footer />
    </div>;
}